import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'militaryToMeridian'
})
export class MilitaryToMeridianPipe implements PipeTransform {

  transform(value: string): string {
    const [hour, minute] = value.split(':').map(Number);
    const isPM = hour >= 12;
    const adjustedHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
    return `${adjustedHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${isPM ? 'PM' : 'AM'}`;
  }
}